/* eslint-disable */
import '../util/cycle';

document.addEventListener('DOMContentLoaded', function() {
  // JavaScript to be fired on product pages

  //////////////////////////////////////////////////////////////////////////
  /////Utitlity ////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////
  let url = new URL(window.location.href);
  let slideParam = url.searchParams.get('slide');
  let tabParam = url.searchParams.get('tab');

  function toggleActive(selector, element) {
    $(selector).each(function() {
      $(this).removeClass('active');
    });
    element.addClass('active');
  }
  let width = $(window).width();

  //////////////////////////////////////////////////////////////////////////
  /////Subnav Dropdown ////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////
  $('#subnav-dropdown').click(function() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');

      if (width < 1024) {
        $('.product-subnav').css('height', '64px');
      } else {
        // $('.product-subnav').css('height', '80px');
      }
    } else {
      $(this).addClass('active');

      if (width < 1024) {
        $('.product-subnav').css(
          'height',
          $('.dropdown-options').height() + 55
        );
      } else {
        // $('.product-subnav').css('height', '140px');
      }
    }
  });

  //////////////////////////////////////////////////////////////////////////
  /////Resize Functions ////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////

  $(window).resize(function() {
    width = $(window).width();
  });

  let initedCarousels = [];

  ///////////////////////////////////////////////////////////////////////////
  /////Accordion Auto Scroll / Open ///////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////
  if (tabParam) {
    const tab = $(`button.btn.${tabParam}`);
    tab[0].scrollIntoView();
    $(`.${tabParam}.collapse`).collapse('toggle');
  }

  ///////////////////////////////////////////////////////////////////////////
  /////Phosphate, Micronutrient Products Component ////////////////////////////
  ///////////////////////////////////////////////////////////////////////////

  $(
    '.section_phosphate_products button, .section_micronutrient_products button '
  ).click(function() {
    const state = $(this).attr('aria-expanded');
    const sibling = $(this).siblings();
    const parent = $(this).parentsUntil('.products');
    const accordion = $(`${$(this).data('target')}.accordion`);
    const carousel = $(
      `.carousel[data-id=${$(this)
        .data('target')
        .replace('#', '')}]`
    );
    const buttonId = $(this)
      .data('target')
      .replace('#', '');

    if (initedCarousels.indexOf(buttonId) == -1) {
      setTimeout(function() {
        carousel.slick(productCarouselOptions);
        initedCarousels.push(buttonId);

        carousel.on(' afterChange', function(event, slick, currentSlide) {
          if (typeof currentSlide != 'undefined') {
            updateImage(currentSlide, accordion);
          }
        });
      }, 100);
    }

    if (state == 'false') {
      sibling.addClass('active');
      parent.addClass('active');
    } else {
      sibling.removeClass('active');
      parent.removeClass('active');
    }
  });

  const productCarouselOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  };

  function updateImage(slideIndex, accordion) {
    const lastImg = accordion.find('img').last();
    const newSrc = $('.slick-active a').data('img');
    lastImg.attr('src', newSrc);
  }

  ///////////////////////////////////////////////////////////////////////////
  /////Supported Crops Component ////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////

  //Init Carousels

  $(`.section_product_supported_crops .collapse`).each(function() {
    $(this).collapse('toggle');
    const name = $(this).data('name');
    const carousel = $(`.carousel.${name}`);
    carousel.slick(productCarouselOptions);
  });

  let timeoutTime = $(window).width() > 768 ? 2000 : 3000;

  setTimeout(function() {
    $(`.section_product_supported_crops .collapse`).each(function() {
      $(this).collapse('toggle');
    });
  }, timeoutTime);

  //Set Event Listener
  let openElement = null;
  $(
    '.section_product_supported_crops button.menu, .section_product_supported_crops .crop img'
  ).each(function() {
    $(this).click(function() {
      const id = $(this).data('id');
      const collapse = $(`.section_product_supported_crops .collapse.${id}`);

      if (openElement && openElement.data('name') != id) {
        const name = openElement.data('name');
        const openButton = $(`button.menu[data-id=${name}]`);

        // alert('different')
        openButton.removeClass('collapsed');
        openElement.collapse('hide');

        openElement = null;
      }
      if ($(this).is('button')) {
        $(this).toggleClass('collapsed');
      } else {
        $(this)
          .siblings()
          .toggleClass('collapsed');
      }

      collapse.collapse('toggle');
      openElement = collapse;
    });
  });

  ///////////////////////////////////////////////////////////////////////////
  /////Product CTA Component ////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////

  const carousel1 = $('.product-cta-carousel');

  carousel1.on(' afterChange', function(event, slick, currentSlide) {
    if (typeof currentSlide != 'undefined') {
      toggleActive(
        '.tab-nav .box .btn',
        $('.tab-nav .box .btn').eq(currentSlide)
      );
    }
  });

  carousel1.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
  });

  $('.tab-nav .box .btn').click(function(e) {
    e.preventDefault();
    toggleActive('.tab-nav .box .btn', $(this));
    const slideIndex = $(this).data('index');
    carousel1.slick('slickGoTo', parseInt(slideIndex));
  });

  // console.log(slideParam);
  let slideIndex = 0;
  if (slideParam) {
    switch (slideParam) {
      case 'acetate':
        slideIndex = 0;
        break;
      case 'biocatalyst':
        slideIndex = 1;
        break;
      case 'c2':
        slideIndex = 2;
        break;
      default:
    }
    $('.section_product_cta')[0].scrollIntoView();
    carousel1.slick('slickGoTo', slideIndex);
  }

  ///////////////////////////////////////////////////////////////////////////
  /////Testimonial Component ////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////
  $('.testimonial').slick({
    // centerMode: true,
    // centerPadding: '0',
    slidesToShow: 3,
    dots: true,
    draggable: true,
    infinite: true,
    appendDots: $('#testimonials .container .left'),
    appendArrows: $('#testimonials .container .left'),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          // centerMode: true,
          // centerPadding: '0',
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 1,
        },
      },
    ],
  });
});



// WEBPACK FOOTER //
// ./scripts/pages/product.js